import SizeInputs, { Sizes } from '@anm/components/SizeInputs';
import { FC } from 'react';

import PlayButtonCheckbox from '../PlayButtonCheckbox';

import { SizesWrapper, Subtitle, Wrapper } from './Wrapper';

type SizesWithButtonProps = {
  sizes: Sizes;
  playButtonStatus: boolean;
  setSizes: (sizes: Sizes) => void;
  handleCheckboxChange: () => void;
};

const SizesWithButton: FC<SizesWithButtonProps> = ({
  sizes,
  setSizes,
  playButtonStatus,
  handleCheckboxChange
}) => (
  <Wrapper>
    <SizesWrapper>
      <Subtitle title="Thumbnail size" level={4} />
      <SizeInputs {...{ sizes }} keepProportion onChange={setSizes} />
    </SizesWrapper>
    <PlayButtonCheckbox
      isChecked={playButtonStatus}
      onCheckBoxChange={handleCheckboxChange}
    />
  </Wrapper>
);

export default SizesWithButton;
